import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'


//colocar props simple && container fluid
const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'secondary'
  ],
  modifiers: [
    {
      title: 'signature',
      isDefault: true
    },
    'bottom'
  ]
}

export default function Footer(props) {
  const { children, data, tag, secondary, gtm = {}, ...rest } = props
  const dataFooter = data
  const CustomTag = tag || 'footer'

  const isSimple = !dataFooter?.social && !React.Children
    .toArray(children).some((x) => x.type?.name === 'FooterList')

  const disclaimer = React.Children.toArray(children).filter((x) => typeof x === 'string')


  return (
    <CustomTag
      {...rest}
      className={`${resolveProps(props, config, 'Footer')} ${isSimple ? 'mdn-Footer--simple' : ''}`}
      role="contentinfo"
    >
      <div className="mdn-Container">
        <div className="mdn-Footer-content">
          <FooterList social={dataFooter?.social} {...props} />
          <div className="mdn-Footer-disclaimer" style={{ textAlign: !isSimple ? 'center' : 'left' }}  >
            {Boolean(disclaimer.toString().trim()) &&
              (
                <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                  <strong>{children}</strong>
                </p>
              )
            }
          </div>
          <div className="mdn-Footer-logo">
            <img
              className="mdn-Footer-logo-image"
              src={
                dataFooter?.imageSrc ||
                'https://mondrian.claro.com.br/brands/nosvg/assinatura-claro.png'
              }
              alt={dataFooter?.imageAlt || 'Logo da Claro'}
            />
          </div>
        </div>
      </div>
    </CustomTag>
  )
}

export function FooterList({ social, gtm ={},  children }) {
  const componentList = React.Children.toArray(children).filter(
    (x) => x.type?.name === 'FooterList'
  )
  if (social) {
    return (
      <ul className="mdn-Footer-list">
        {social?.map((icon, index) => {
          //const hasHref =

          const { gtmClassName = "", dataGTM = {} } = gtm

          return (
            <li key={index} className="mdn-Footer-list-item">
              {
                icon?.href
                  ?
                  (
                    <a href={icon.href} className={`${gtmClassName}`} {...dataGTM} >
                      <span className={`mdn-Icon-${icon.icon} mdn-Icon--md`}></span>
                    </a>
                  )
                  :
                  (
                    <span className={`mdn-Icon-${icon.icon} mdn-Icon--md mdn-Text--inverse`}></span>
                  )
              }
            </li>
          )
        })}
      </ul>
    )
  }
  if (!!componentList.length) {
    const child = componentList[0]
    return (
      <div className="mdn-Footer-list">
        { child.props.children}
      </div>
    )
  }

  return null
}

Footer.propTypes = {
  children: PropTypes.node,
  secondary: PropTypes.bool,
  data: PropTypes.object,
  tag: PropTypes.string
}
